// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1B920{margin-top:1rem;color:#595757;max-width:528px;max-width:33rem;font-size:18px;font-size:1.125rem;font-weight:400;line-height:29px;line-height:1.8125rem;font-family:var(--base-font)}.ew392{margin-top:1rem;width:100vw;position:relative;left:-96px;left:-6rem}@media(min-width:1024px)and (max-width:1439px){.ew392{left:-3rem}}@media(min-width:768px)and (max-width:1023px)and (orientation:portrait){.ew392{left:-2rem}}@media(max-width:767px){.ew392{left:-1rem}}._2BM9d{margin-top:2rem;width:100%}._3DDw7{margin-top:3rem}._1QN4q{margin-top:2rem}section.WnpsT{margin:6.75rem 0 2.800625rem;width:100%}@media(min-width:1440px){section.WnpsT{max-width:100%}}._1Uu5b{max-width:100%;margin:0 6rem}@media(min-width:1024px)and (max-width:1439px){._1Uu5b{margin-left:3rem;margin-right:3rem}}@media(max-width:1023px){._1Uu5b{margin-left:2.5rem;margin-right:2.5rem}}@media(max-width:767px){._1Uu5b{margin-left:1rem;margin-right:1rem}}.HLgyX{padding:0;width:100%;margin:0;max-width:none}", ""]);
// Exports
exports.locals = {
	"subTitle": "_1B920",
	"bannerList": "ew392",
	"groupList": "_2BM9d",
	"gradeLevel": "_3DDw7",
	"courseList": "_1QN4q",
	"feature": "WnpsT",
	"activeFeature": "_1Uu5b",
	"testimonial": "HLgyX"
};
module.exports = exports;
